/**
 * ViewInACCButton Component
 * Button/link to view report in Autodesk Construction Cloud
 */
import { useState } from 'react'
import { getACCUrl } from '../utils/accUtils'
import '../styles/ViewInACCButton.css'

export default function ViewInACCButton({ report, projectId, templateId }) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <a
      href={getACCUrl(report, projectId, templateId)}
      target="_blank"
      rel="noopener noreferrer"
      className="view-in-acc-button"
      style={{
        backgroundColor: isHovered ? '#fef3c7' : '#fef3c7',
        color: isHovered ? '#d97706' : '#f59e0b',
        border: `1px solid ${isHovered ? '#fbbf24' : '#fcd34d'}`
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        <polyline points="15 3 21 3 21 9" />
        <line x1="10" y1="14" x2="21" y2="3" />
      </svg>
      View in ACC
    </a>
  )
}
